"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vendorProductSync = exports.updateActivationVendor = exports.selectVendor = exports.saveVendor = exports.getVendorsList = exports.getVendors = exports.getVendorProducts = exports.getVendorProductSyncLog = exports.getVendorContacts = exports.getFilteredVendors = exports.getAcquireVendors = exports.deleteVendor = exports.createVendor = exports.acquireVendor = exports.acquireProductRequest = exports.acquireProduct = exports.VENDORPRODUCTS_SYNC_SUCCESS = exports.VENDORPRODUCTS_SYNC_REQUEST = exports.VENDORPRODUCTS_SYNC_FAILURE = exports.UPDATE_ACTIVATION_SUCCESS = exports.UPDATE_ACTIVATION_REQUEST = exports.UPDATE_ACTIVATION_FAILURE = exports.SET_VENDOR_PRODUCTS = exports.SELECT_VENDOR_SUCCESS = exports.SELECT_VENDOR_REQUEST = exports.SELECT_VENDOR_FAILURE = exports.SAVE_VENDOR_SUCCESS = exports.SAVE_VENDOR_REQUEST = exports.SAVE_VENDOR_FAILURE = exports.GET_VENDOR_PRODUCTS_SUCCESS = exports.GET_VENDOR_PRODUCTS_REQUEST = exports.GET_VENDOR_PRODUCTS_FAILURE = exports.GET_VENDOR_CONTACTS_SUCCESS = exports.GET_VENDOR_CONTACTS_REQUEST = exports.GET_VENDOR_CONTACTS_FAILURE = exports.GET_VENDORS_SUCCESS = exports.GET_VENDORS_REQUEST = exports.GET_VENDORS_LIST_SUCCESS = exports.GET_VENDORS_LIST_REQUEST = exports.GET_VENDORS_LIST_FAILURE = exports.GET_VENDORS_FAILURE = exports.GET_VENDORPRODUCTS_SYNC_LOG_SUCCESS = exports.GET_VENDORPRODUCTS_SYNC_LOG_REQUEST = exports.GET_VENDORPRODUCTS_SYNC_LOG_FAILURE = exports.GET_FILTERED_VENDORS_SUCCESS = exports.GET_FILTERED_VENDORS_REQUEST = exports.GET_FILTERED_VENDORS_FAILURE = exports.GET_ACQUIRE_VENDORS_SUCCESS = exports.GET_ACQUIRE_VENDORS_REQUEST = exports.GET_ACQUIRE_VENDORS_FAILURE = exports.DELETE_VENDOR_SUCCESS = exports.DELETE_VENDOR_REQUEST = exports.DELETE_VENDOR_FAILURE = exports.CREATE_VENDOR_SUCCESS = exports.CREATE_VENDOR_REQUEST = exports.CREATE_VENDOR_FAILURE = exports.ACQUIRE_VENDOR_SUCCESS = exports.ACQUIRE_VENDOR_REQUEST = exports.ACQUIRE_VENDOR_FAILURE = exports.ACQUIRE_PRODUCT_SUCCESS = exports.ACQUIRE_PRODUCT_REQUEST = exports.ACQUIRE_PRODUCT_FAILURE = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _api = require("../middleware/api");
var GET_VENDORS_REQUEST = exports.GET_VENDORS_REQUEST = 'GET_VENDORS_REQUEST';
var GET_VENDORS_SUCCESS = exports.GET_VENDORS_SUCCESS = 'GET_VENDORS_SUCCESS';
var GET_VENDORS_FAILURE = exports.GET_VENDORS_FAILURE = 'GET_VENDORS_FAILURE';
var GET_FILTERED_VENDORS_REQUEST = exports.GET_FILTERED_VENDORS_REQUEST = 'GET_FILTERED_VENDORS_REQUEST';
var GET_FILTERED_VENDORS_SUCCESS = exports.GET_FILTERED_VENDORS_SUCCESS = 'GET_FILTERED_VENDORS_SUCCESS';
var GET_FILTERED_VENDORS_FAILURE = exports.GET_FILTERED_VENDORS_FAILURE = 'GET_FILTERED_VENDORS_FAILURE';
var GET_VENDORS_LIST_REQUEST = exports.GET_VENDORS_LIST_REQUEST = 'GET_VENDORS_LIST_REQUEST';
var GET_VENDORS_LIST_SUCCESS = exports.GET_VENDORS_LIST_SUCCESS = 'GET_VENDORS_LIST_SUCCESS';
var GET_VENDORS_LIST_FAILURE = exports.GET_VENDORS_LIST_FAILURE = 'GET_VENDORS_LIST_FAILURE';
var GET_ACQUIRE_VENDORS_REQUEST = exports.GET_ACQUIRE_VENDORS_REQUEST = 'GET_ACQUIRE_VENDORS_REQUEST';
var GET_ACQUIRE_VENDORS_SUCCESS = exports.GET_ACQUIRE_VENDORS_SUCCESS = 'GET_ACQUIRE_VENDORS_SUCCESS';
var GET_ACQUIRE_VENDORS_FAILURE = exports.GET_ACQUIRE_VENDORS_FAILURE = 'GET_ACQUIRE_VENDORS_FAILURE';
var GET_VENDOR_PRODUCTS_REQUEST = exports.GET_VENDOR_PRODUCTS_REQUEST = 'GET_VENDOR_PRODUCTS_REQUEST';
var GET_VENDOR_PRODUCTS_SUCCESS = exports.GET_VENDOR_PRODUCTS_SUCCESS = 'GET_VENDOR_PRODUCTS_SUCCESS';
var GET_VENDOR_PRODUCTS_FAILURE = exports.GET_VENDOR_PRODUCTS_FAILURE = 'GET_VENDOR_PRODUCTS_FAILURE';
var SELECT_VENDOR_REQUEST = exports.SELECT_VENDOR_REQUEST = 'SELECT_VENDOR_REQUEST';
var SELECT_VENDOR_SUCCESS = exports.SELECT_VENDOR_SUCCESS = 'SELECT_VENDOR_SUCCESS';
var SELECT_VENDOR_FAILURE = exports.SELECT_VENDOR_FAILURE = 'SELECT_VENDOR_FAILURE';
var GET_VENDOR_CONTACTS_REQUEST = exports.GET_VENDOR_CONTACTS_REQUEST = 'GET_VENDOR_CONTACTS_REQUEST';
var GET_VENDOR_CONTACTS_SUCCESS = exports.GET_VENDOR_CONTACTS_SUCCESS = 'GET_VENDOR_CONTACTS_SUCCESS';
var GET_VENDOR_CONTACTS_FAILURE = exports.GET_VENDOR_CONTACTS_FAILURE = 'GET_VENDOR_CONTACTS_FAILURE';
var CREATE_VENDOR_REQUEST = exports.CREATE_VENDOR_REQUEST = 'CREATE_VENDOR_REQUEST';
var CREATE_VENDOR_SUCCESS = exports.CREATE_VENDOR_SUCCESS = 'CREATE_VENDOR_SUCCESS';
var CREATE_VENDOR_FAILURE = exports.CREATE_VENDOR_FAILURE = 'CREATE_VENDOR_FAILURE';
var SAVE_VENDOR_REQUEST = exports.SAVE_VENDOR_REQUEST = 'SAVE_VENDOR_REQUEST';
var SAVE_VENDOR_SUCCESS = exports.SAVE_VENDOR_SUCCESS = 'SAVE_VENDOR_SUCCESS';
var SAVE_VENDOR_FAILURE = exports.SAVE_VENDOR_FAILURE = 'SAVE_VENDOR_FAILURE';
var DELETE_VENDOR_REQUEST = exports.DELETE_VENDOR_REQUEST = 'DELETE_VENDOR_REQUEST';
var DELETE_VENDOR_SUCCESS = exports.DELETE_VENDOR_SUCCESS = 'DELETE_VENDOR_SUCCESS';
var DELETE_VENDOR_FAILURE = exports.DELETE_VENDOR_FAILURE = 'DELETE_VENDOR_FAILURE';
var UPDATE_ACTIVATION_REQUEST = exports.UPDATE_ACTIVATION_REQUEST = 'UPDATE_ACTIVATION_REQUEST';
var UPDATE_ACTIVATION_SUCCESS = exports.UPDATE_ACTIVATION_SUCCESS = 'UPDATE_ACTIVATION_SUCCESS';
var UPDATE_ACTIVATION_FAILURE = exports.UPDATE_ACTIVATION_FAILURE = 'UPDATE_ACTIVATION_FAILURE';
var ACQUIRE_PRODUCT_REQUEST = exports.ACQUIRE_PRODUCT_REQUEST = 'ACQUIRE_PRODUCT_REQUEST';
var ACQUIRE_PRODUCT_SUCCESS = exports.ACQUIRE_PRODUCT_SUCCESS = 'ACQUIRE_PRODUCT_SUCCESS';
var ACQUIRE_PRODUCT_FAILURE = exports.ACQUIRE_PRODUCT_FAILURE = 'ACQUIRE_PRODUCT_FAILURE';
var ACQUIRE_VENDOR_REQUEST = exports.ACQUIRE_VENDOR_REQUEST = 'ACQUIRE_VENDOR_REQUEST';
var ACQUIRE_VENDOR_SUCCESS = exports.ACQUIRE_VENDOR_SUCCESS = 'ACQUIRE_VENDOR_SUCCESS';
var ACQUIRE_VENDOR_FAILURE = exports.ACQUIRE_VENDOR_FAILURE = 'ACQUIRE_VENDOR_FAILURE';
var SET_VENDOR_PRODUCTS = exports.SET_VENDOR_PRODUCTS = 'SET_VENDOR_PRODUCTS';
var GET_VENDORPRODUCTS_SYNC_LOG_REQUEST = exports.GET_VENDORPRODUCTS_SYNC_LOG_REQUEST = 'GET_VENDORPRODUCTS_SYNC_LOG_REQUEST';
var GET_VENDORPRODUCTS_SYNC_LOG_SUCCESS = exports.GET_VENDORPRODUCTS_SYNC_LOG_SUCCESS = 'GET_VENDORPRODUCTS_SYNC_LOG_SUCCESS';
var GET_VENDORPRODUCTS_SYNC_LOG_FAILURE = exports.GET_VENDORPRODUCTS_SYNC_LOG_FAILURE = 'GET_VENDORPRODUCTS_SYNC_LOG_FAILURE';
var VENDORPRODUCTS_SYNC_REQUEST = exports.VENDORPRODUCTS_SYNC_REQUEST = 'VENDORPRODUCTS_SYNC_REQUEST';
var VENDORPRODUCTS_SYNC_SUCCESS = exports.VENDORPRODUCTS_SYNC_SUCCESS = 'VENDORPRODUCTS_SYNC_SUCCESS';
var VENDORPRODUCTS_SYNC_FAILURE = exports.VENDORPRODUCTS_SYNC_FAILURE = 'VENDORPRODUCTS_SYNC_FAILURE';
var vendorProductSync = exports.vendorProductSync = function vendorProductSync() {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [VENDORPRODUCTS_SYNC_REQUEST, VENDORPRODUCTS_SYNC_SUCCESS, VENDORPRODUCTS_SYNC_FAILURE],
    authenticated: true,
    endpoint: "vendors/VendorProductSync",
    method: 'POST',
    payload: {}
  });
};
var getVendorProductSyncLog = exports.getVendorProductSyncLog = function getVendorProductSyncLog() {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_VENDORPRODUCTS_SYNC_LOG_REQUEST, GET_VENDORPRODUCTS_SYNC_LOG_SUCCESS, GET_VENDORPRODUCTS_SYNC_LOG_FAILURE],
    authenticated: true,
    endpoint: "vendors/VendorProductSyncLogs",
    method: 'GET'
  });
};
var getVendors = exports.getVendors = function getVendors() {
  var queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_VENDORS_REQUEST, GET_VENDORS_SUCCESS, GET_VENDORS_FAILURE],
    authenticated: true,
    endpoint: "vendors".concat(queryString ? "?".concat(queryString) : ''),
    method: 'GET'
  });
};
var getFilteredVendors = exports.getFilteredVendors = function getFilteredVendors() {
  var queryString = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_FILTERED_VENDORS_REQUEST, GET_FILTERED_VENDORS_SUCCESS, GET_FILTERED_VENDORS_FAILURE],
    authenticated: true,
    endpoint: "vendors?".concat(queryString),
    method: 'GET'
  });
};
var getVendorsList = exports.getVendorsList = function getVendorsList() {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_VENDORS_LIST_REQUEST, GET_VENDORS_LIST_SUCCESS, GET_VENDORS_LIST_FAILURE],
    authenticated: true,
    endpoint: "vendors/list",
    method: 'GET'
  });
};
var getAcquireVendors = exports.getAcquireVendors = function getAcquireVendors(vendorID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_ACQUIRE_VENDORS_REQUEST, GET_ACQUIRE_VENDORS_SUCCESS, GET_ACQUIRE_VENDORS_FAILURE],
    authenticated: true,
    endpoint: "vendors/forAcquisition/".concat(vendorID),
    method: 'GET'
  });
};
var selectVendor = exports.selectVendor = function selectVendor(vendorID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [SELECT_VENDOR_REQUEST, SELECT_VENDOR_SUCCESS, SELECT_VENDOR_FAILURE],
    authenticated: true,
    endpoint: "vendors/".concat(vendorID),
    method: 'GET'
  });
};
var getVendorContacts = exports.getVendorContacts = function getVendorContacts(vendorID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_VENDOR_CONTACTS_REQUEST, GET_VENDOR_CONTACTS_SUCCESS, GET_VENDOR_CONTACTS_FAILURE],
    authenticated: true,
    endpoint: "https://mobile.app.himssanalytics.org/v1/vendors/".concat(vendorID),
    method: 'GET'
  });
};
var getVendorProducts = exports.getVendorProducts = function getVendorProducts(vendorID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [GET_VENDOR_PRODUCTS_REQUEST, GET_VENDOR_PRODUCTS_SUCCESS, GET_VENDOR_PRODUCTS_FAILURE],
    authenticated: true,
    endpoint: "vendors/".concat(vendorID, "/products"),
    method: 'GET'
  });
};
var createVendor = exports.createVendor = function createVendor(data) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [CREATE_VENDOR_REQUEST, CREATE_VENDOR_SUCCESS, CREATE_VENDOR_FAILURE],
    authenticated: true,
    endpoint: "vendors",
    method: 'POST',
    payload: data
  });
};
var saveVendor = exports.saveVendor = function saveVendor(vendorID, data) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [SAVE_VENDOR_REQUEST, SAVE_VENDOR_SUCCESS, SAVE_VENDOR_FAILURE],
    authenticated: true,
    endpoint: "vendors/".concat(vendorID),
    method: 'PUT',
    payload: data
  });
};
var updateActivationVendor = exports.updateActivationVendor = function updateActivationVendor(vendorID, data) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [UPDATE_ACTIVATION_REQUEST, UPDATE_ACTIVATION_SUCCESS, UPDATE_ACTIVATION_FAILURE],
    authenticated: true,
    endpoint: "vendors/".concat(vendorID),
    method: 'PUT',
    payload: data
  });
};
var deleteVendor = exports.deleteVendor = function deleteVendor(vendorID) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [DELETE_VENDOR_REQUEST, DELETE_VENDOR_SUCCESS, DELETE_VENDOR_FAILURE],
    authenticated: true,
    endpoint: "vendors/".concat(vendorID),
    method: 'DELETE'
  });
};
var acquireProduct = exports.acquireProduct = function acquireProduct(vendorID, data) {
  return /*#__PURE__*/function () {
    var _ref12 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(dispatch, getState) {
      var resp;
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return dispatch(acquireProductRequest(vendorID, data));
          case 1:
            resp = _context.sent;
            dispatch(getAcquireVendors());
            return _context.abrupt("return", resp);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref12.apply(this, arguments);
    };
  }();
};
var acquireVendor = exports.acquireVendor = function acquireVendor(vendorID, data) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [ACQUIRE_VENDOR_REQUEST, ACQUIRE_VENDOR_SUCCESS, ACQUIRE_VENDOR_FAILURE],
    authenticated: true,
    endpoint: "vendors/".concat(vendorID, "/mergeVendor"),
    method: 'POST',
    payload: data
  });
};
var acquireProductRequest = exports.acquireProductRequest = function acquireProductRequest(vendorID, data) {
  return (0, _defineProperty2["default"])({}, _api.CALL_API, {
    types: [ACQUIRE_PRODUCT_REQUEST, ACQUIRE_PRODUCT_SUCCESS, ACQUIRE_PRODUCT_FAILURE],
    authenticated: true,
    endpoint: "vendors/".concat(vendorID, "/productAcquisition"),
    method: 'POST',
    payload: data
  });
};